import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-testimonial-carousel',
  templateUrl: './testimonial-carousel.component.html',
  styleUrls: ['./testimonial-carousel.component.scss']
})
export class TestimonialCarouselComponent implements OnInit, OnDestroy {

  urlBlobStorage = environment.blobstorage;

  testimonials = [
    {
      name: 'Juan',
      age: '23 años',
      image: `${this.urlBlobStorage}Home/Testimonial-carousel/Juan.webp`,  
      comment: '"Gran Titán ha sido una de las mejores experiencias de mi vida, me permitió certificar mi primera experiencia laboral, que ahora me ayudará a buscar empleo."'
    },
    {
      name: 'Paulina',
      age: '21 años',
      image: `${this.urlBlobStorage}Home/Testimonial-carousel/Paulina.webp`,  
      comment: '"Un camino para construir una mejor versión de mí. Eso es Gran Titán en mi vida, me aportó ingresos para hacer el curso de inglés que tanto quería."'
    },
    {
      name: 'Andrea',
      age: '25 años',
      image: `${this.urlBlobStorage}Home/Testimonial-carousel/Andrea.webp`,  
      comment: '"Había escuchado sobre marketing digital pero no sabía cómo funcionaba. Gran Titán me capacitó y me enseñó cómo atraer a cientos de personas con mi labor."'
    },
    {
      name: 'Tomas',
      age: '19 años',
      image: `${this.urlBlobStorage}Home/Testimonial-carousel/Tomas.webp`,  
      comment: '"Estaba desesperado porque no tenía cómo empezar a generar ingresos y apoyar mis gastos universitarios. En Gran Titán descubrí una manera fácil y divertida de hacerlo."'
    }
  ];

  
  currentIndex = 0;
  autoChangeInterval: any;

  ngOnInit() {
    this.startAutoChangeSlide();
  }

  ngOnDestroy() {
    this.stopAutoChangeSlide();
  }

  startAutoChangeSlide() {
    this.autoChangeInterval = setInterval(() => {
      const nextIndex = (this.currentIndex + 1) % this.testimonials.length;
      this.goToTestimonial(nextIndex);
    }, 15000);
  }
  
  stopAutoChangeSlide() {
    clearInterval(this.autoChangeInterval);
  }

  goToTestimonial(index: number) {
    this.currentIndex = index;
  }
}
